import { computed } from 'vue';
import { featureFlagsState } from '@/utils/featureFlags';

/**
 * Valor reactivo de un feature flag de LaunchDarkly
 * @param {string} key - key del flag (FEATURE_FLAGS.<FLAG>.key)
 * @returns {import('vue').ComputedRef<*>}
 */
export const useFeatureFlag = (key) => computed(() => featureFlagsState.flags[key]);

export default useFeatureFlag;
